import { useLayoutEffect } from 'react';
import {
  applyUiPreferencesFromUser,
  UI_PREFERENCES_EVENT,
} from '../../utils/uiPreferences';
import { applyShellTheme, getStoredShellTheme } from '../../utils/shellTheme';
import { applySidebarMode, getAccountSidebarMode } from '../../utils/sidebarMode';

/**
 * Keeps shell backdrop in sync with stored prefs.
 * Live sidebar density is owned by AppShell (session); only adopt the saved
 * default when an event explicitly signals sidebar_mode changed.
 */
export default function ShellThemeApplier() {
  useLayoutEffect(() => {
    const applyShellFromStorage = () => {
      applyShellTheme(getStoredShellTheme());
    };

    const onPrefs = (e) => {
      applyShellFromStorage();
      // Do not reset ☰ session density when backdrop/other prefs change
      if (e?.detail?.sidebar_mode === true) {
        applySidebarMode(getAccountSidebarMode());
      }
    };

    try {
      const raw = sessionStorage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      applyUiPreferencesFromUser(user);
    } catch {
      applyShellFromStorage();
      applySidebarMode(getAccountSidebarMode());
    }

    window.addEventListener(UI_PREFERENCES_EVENT, onPrefs);
    return () => window.removeEventListener(UI_PREFERENCES_EVENT, onPrefs);
  }, []);

  return null;
}
